import { useFind, usePopulate } from './APIHooks';

export const useValueSet = (computableName) => {
  const { data, isLoading, isFetching } = useFind(
    'value_set',
    { computable_name: computableName, status: 'active' },
    {
      page: { size: 1 },
      queryConfig: {
        placeholderData: undefined,
        staleTime: Infinity,
        refetchOnWindowFocus: false,
      },
    },
  );

  const valueSetRecord = data?.data?.data?.[0] ?? null;

  const { isLoading: isConceptsLoading } = usePopulate(
    'concepts',
    'concept',
    valueSetRecord,
    {
      queryConfig: {
        enabled: !!valueSetRecord,
        placeholderData: undefined,
      },
    },
  );

  const concepts = valueSetRecord?.concepts ?? [];

  const options = concepts.map((concept) => ({
    label: concept?.display ?? concept?.attributes?.display ?? concept?.id ?? '',
    value: concept.id,
  }));

  const conceptId = concepts[0]?.id;

  return {
    concepts,
    options,
    conceptId,
    isLoading: isLoading || isFetching || isConceptsLoading,
  };
};
